export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=406f89a0fb0cdcc6c965e90b1974aff20f8aaa3c9c&name=revalidateCommunity!'